import React from "react";
import DeptIcon from "../../../../../Assets/Images/Department-icon.svg";

const ManagerInfo = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const shortenText = (Text) => {
    if (Text.length > 20 && window.innerWidth >= 600 && window.innerWidth <=1024) {
      return Text.slice(0,17)+'...'
    }
    return Text
  }

  return (
    <div className="info-wrapper">
      <section className="info-wrapper-head">
        <i className="feather-x" onClick={() => props.Close()}></i>
        {props.Type === "position" ? (
          <h1>{translateText("hiring_manager_info")}</h1>
        ) : (
          <React.Fragment>
            {props.Type === "project" ? (
              <h1>{translateText("project_manager_info")}</h1>
            ) : (
              <h1>{translateText("activity_owner_info")}</h1>
            )}
          </React.Fragment>
        )}
      </section>
      {props.Data === undefined ? null : (
        <div className="info-main-content ">
          <div className="main-info">
            {props.Data.imageThumbnailUrl === null ? (
              <span
                className="avatar-placeholder"
                style={{
                  background: props.Data.backgroundColorCode,
                  color: props.Data.textColorCode,
                }}
              >
                {props.Data.firstName.slice(0, 1).toUpperCase() +
                  props.Data.lastName.slice(0, 1).toUpperCase()}
              </span>
            ) : (
              <img alt="user" src={props.Data.imageThumbnailUrl} />
            )}
            <section className="user-info-grid">
              <h1>{props.Data.firstName + " " + props.Data.lastName}</h1>
              <p>{props.Data.currentPositionTitle}</p>
            </section>
          </div>
          <div className="detailed-info">
            <section className="detailed-info-column">
              {props.Type === "position" ? (
                <h1 className="info-column-title">
                  {translateText("hiring_manager_details")}
                </h1>
              ) : (
                <React.Fragment>
                  {props.Type === "project" ? (
                    <h1 className="info-column-title">
                      {translateText("project_manager_details")}
                    </h1>
                  ) : (
                    <h1 className="info-column-title">
                      {translateText("activity_owner_details")}
                    </h1>
                  )}
                </React.Fragment>
              )}
              <div className="info-row">
                <i className="feather-globe"></i>
                <section className="row-info-grid">
                  <p className="row-info-title">{translateText("language")}</p>
                  {props.Data.language === null ? (
                    <p className="not-available-text">
                      {translateText("not_available")}
                    </p>
                  ) : (
                    <p className="row-info-text">
                      {props.Data.language.map((Lang, i) => (
                        <React.Fragment>
                          {i > 0 && i + 1 < props.Data.language.length
                            ? Lang + ","
                            : Lang}
                        </React.Fragment>
                      ))}
                    </p>
                  )}
                </section>
              </div>
              <div className="info-row">
                <img alt="department" src={DeptIcon} />
                <section className="row-info-grid">
                  <p className="row-info-title">
                    {translateText("department")}
                  </p>
                  {props.Data.departmentName === null ? (
                    <p className="not-available-text">
                      {translateText("not_available")}
                    </p>
                  ) : (
                    <p className="row-info-text">{props.Data.departmentName}</p>
                  )}
                </section>
              </div>
              <div className="info-row">
                <i className="feather-map-pin"></i>
                <section className="row-info-grid">
                  <p className="row-info-title">{translateText("home_city")}</p>
                  {props.Data.homeCity === null ? (
                    <p className="not-available-text">
                      {translateText("not_available")}
                    </p>
                  ) : (
                    <p className="row-info-text">{props.Data.homeCity}</p>
                  )}
                </section>
              </div>
            </section>
            <section className="detailed-info-column">
              <h1 className="info-column-title">
                {translateText("contact_info")}
              </h1>
              <div className="info-row">
                <i className="feather-mail"></i>
                <section className="row-info-grid">
                  <p className="row-info-title">Email</p>
                  {props.Data.email === null ? (
                    <p className="not-available-text">
                      {translateText("not_available")}
                    </p>
                  ) : (
                    <p className="row-info-text">{shortenText(props.Data.email)}</p>
                  )}
                </section>
              </div>
              <div className="info-row">
                <i className="feather-smartphone"></i>
                <section className="row-info-grid">
                  <p className="row-info-title">Mobile</p>
                  {props.Data.workMobile === null ? (
                    <p className="not-available-text">
                      {translateText("not_available")}
                    </p>
                  ) : (
                    <p className="row-info-text">{props.Data.workMobile}</p>
                  )}
                </section>
              </div>
              <div className="info-row">
                <i className="feather-phone"></i>
                <section className="row-info-grid">
                  <p className="row-info-title">
                    {translateText("work_phone")}
                  </p>
                  {props.Data.workPhone === null ? (
                    <p className="not-available-text">
                      {translateText("not_available")}
                    </p>
                  ) : (
                    <p className="row-info-text">{props.Data.workPhone}</p>
                  )}
                </section>
              </div>
            </section>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManagerInfo;
